import React from "react";
import ExceltoWord from "./ExceltoWord";
import "react-datepicker/dist/react-datepicker.css";
import { Card, createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import Grid from "@mui/material/Grid";

const defaultMaterialTheme = createTheme({
  palette: {
    primary: {
      main: "#008752",
    },
  },
  backdrop: {
    zIndex: 9999999,
    color: "#000",
  },
});

function ExcelConversion() {
  return (
    <ExceltoWord />
          
  );
}

export default ExcelConversion;